import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDqwe11trltDpn3WYwfIncKPP6eMDpdxrM",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "hifilabs-proto-tryon.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "hifilabs-proto-tryon",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "hifilabs-proto-tryon.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "488271490346",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:488271490346:web:3deb22dd827d4ef8690253",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-LGGTW20P84"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore (using 'tryon' database — default is Datastore Mode incompatible with Firebase SDK)
export const db = getFirestore(app, 'tryon');

// Initialize Storage
export const storage = getStorage(app);

// Connect to emulators in development
if (window.location.hostname === 'localhost') {
  console.log('🔧 Connecting to Firebase Emulators...');

  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('✅ Firestore emulator connected: localhost:8080');
  } catch (error) {
    console.warn('⚠️ Firestore emulator already connected or failed:', error.message);
  }

  try {
    connectStorageEmulator(storage, 'localhost', 9199);
    console.log('✅ Storage emulator connected: localhost:9199');
  } catch (error) {
    console.warn('⚠️ Storage emulator already connected or failed:', error.message);
  }
}

export default app;
